import React, { useState, useEffect } from "react";
import { Grid, Divider, Button, Header, Form } from "semantic-ui-react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import axios from "axios";
import { Field, reduxForm } from "redux-form";
import { renderRadioField, renderTextField } from "../formcomponents";
import { BaseUrlInvoice } from "../formcomponents/Constants";
const ExpiryDoc = (props) => {
  const { handleSubmit, pristine, submitting, reset } = props;
  const sumbitForm = (values) => {
    //accounts/listExpiringDocuments

    console.log("values", values);
    axios
      .post(BaseUrlInvoice + "accounts/listExpiringDocuments", values)
      .then((res) => {
        setRecordForTable(res.data);

        console.log("Expiry Doc", res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const [rowData, setrowData] = useState("");
  const setRecordForTable = (record) => {
    const tempRecord = record.map(
      ({
        companyId,
        companyName,
        fileDescription,
        fileExpiry,
        fileType,
        nofDaysToExpiry,
      }) => ({
        companyId,
        companyName,
        fileDescription,
        fileExpiry,
        fileType,
        nofDaysToExpiry,
      })
    );
    setrowData(tempRecord);
  };
  const columnDefs = [
    { headerName: "Name ", field: "companyName" },

    { headerName: "Description", field: "fileDescription" },
    { headerName: "Expiry Date", field: "fileExpiry" },
    { headerName: "File Type", field: "fileType" },
    { headerName: "Days Remaining", field: "nofDaysToExpiry" },

    {
      headerName: "Send Email",
      filter: false,
      field: "companyId",
      cellRendererFramework: (params) => (
        <div>
          <Button color="primary" onClick={() => actionButton(params)}>
            Send Email
          </Button>
        </div>
      ),
    },
  ];

  const actionButton = (params) => {
    console.log(params.data.dailyWorkId);

    // history.push(
    //   `/attraction/attraction-creation/${params.data.attractionsId}`
    // ); /
  };

  const defaultColDef = {
    sortable: true,
    editable: true,
    flex: 1,
    filter: true,
    floatingFilter: true,
  };

  return (
    <div>
      <Grid.Row>
        <Header dividing size="huge" as="h1">
          Expiry Details
        </Header>
      </Grid.Row>
      <Divider hidden /> <Divider hidden />
      <Grid.Row>
        <Grid columns="five">
          <Grid.Row>
            <Form.Group>
              <div
                style={{
                  display: "flex",
                }}
              >
                <label
                  style={{
                    marginRight: "10px",
                  }}
                >
                  Expiry Date
                </label>
                <div
                  style={{
                    marginRight: "20px",
                  }}
                >
                  <Field
                    component={renderRadioField}
                    label="5 - days"
                    name="nofDaysToExpiry"
                    radioValue={5}
                  />
                </div>
                <div
                  style={{
                    marginRight: "20px",
                  }}
                >
                  <Field
                    component={renderRadioField}
                    label="15 - days"
                    name="nofDaysToExpiry"
                    radioValue={15}
                  />
                </div>
                <div
                  style={{
                    marginRight: "20px",
                  }}
                >
                  <Field
                    component={renderRadioField}
                    label="30 - days"
                    name="nofDaysToExpiry"
                    radioValue={30}
                  />
                </div>

                <Field
                  component={renderRadioField}
                  label="Already Expired"
                  name="nofDaysToExpiry"
                  radioValue={0}
                />
              </div>
            </Form.Group>
          </Grid.Row>
        </Grid>
        <Button
          type="submit"
          floated="right"
          positive
          disabled={submitting}
          onClick={handleSubmit((values) =>
            sumbitForm({
              ...values,
            })
          )}
        >
          Get Report
        </Button>
      </Grid.Row>
      <br />
      <br />
      <Grid.Row>
        <div className="ag-theme-alpine" style={{ height: 600 }}>
          <AgGridReact
            rowData={rowData}
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            pagination={true}
          ></AgGridReact>
        </div>
      </Grid.Row>
    </div>
  );
};

export default reduxForm({
  form: "ExpiryDoc",
})(ExpiryDoc);
